import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const navLinks = [
    { to: '/', label: 'Forside' },
    { to: '/byg-garanti', label: 'Bygge Garanti' },
    { to: '/om-os', label: 'Om Os' },
    { to: '/kontakt', label: 'Kontakt' },
    { to: '/galleri', label: 'Galleri' },
  ];

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50 h-20 opacity-90 rounded-b-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full">
          {/* Logo Section */}
          <Link to="/" className="flex items-center gap-2 h-full">
            <img 
              src="/media/header/LOGO_WHITENOTEXT.jpg" 
              alt="Murermester Voss Logo" 
              className="h-20 w-auto object-contain"
            />
            <div className="md:block">
              <h3 
                className="text-xl font-bold text-primary uppercase"
                style={{ textShadow: '23px 23px 26px rgba(0, 0, 0, 0.9)' }}
              >
                Murermester Voss
              </h3>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:block">
            <ul className="flex gap-6 items-center">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to}
                    className="text-gray-800 hover:text-secondary transition-colors duration-300 font-medium"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden w-10 h-12 flex flex-col justify-center items-center relative focus:outline-none z-[60]"
            aria-label="Toggle menu"
          >
            <span className={`block w-full h-1.5 bg-black rounded transition-all duration-300 absolute ${isMenuOpen ? 'rotate-45 translate-y-0' : '-translate-y-3'}`} />
            <span className={`block w-full h-1.5 bg-black rounded transition-all duration-300 absolute ${isMenuOpen ? '-rotate-45 translate-y-0' : 'translate-y-0'}`} />
            <span className={`block w-full h-1.5 bg-black rounded transition-all duration-300 absolute ${isMenuOpen ? 'opacity-0' : 'translate-y-3'}`} />
          </button>
        </div>
      </div>

      {/* Overlay - Lower z-index (40) */}
      {isMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        />
      )}

      {/* Mobile Menu - Higher z-index (50) */}
      <div className={`lg:hidden fixed top-0 left-0 w-3/5 h-screen bg-white shadow-lg transform transition-transform duration-400 z-50 ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="pt-20 px-6">
          <Link to="/" className="block mb-6">
            <img 
              src="/media/header/LOGO_WHITENOTEXT.jpg" 
              alt="Logo" 
              className="h-20 w-auto"
            />
          </Link>
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  onClick={toggleMenu}
                  className="text-base uppercase text-gray-800 hover:text-secondary hover:bg-gray-100 transition-all block py-3 px-4 font-bold border-2 border-gray-300 rounded-lg hover:border-primary"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;